import { NavLink } from "hooks/useCustomNavigation";
import "./index.scss";
import { LINK_LIST } from "./utils/linkList";

export const PortalFooterLink = () => (
  <nav className="portal-footer-link">
    <ul className="link-desktop">
      {LINK_LIST.desktop.map(({ label, url }) => (
        <li key={label}>
          <NavLink to={url} aria-label={label}>
            {label}
          </NavLink>
        </li>
      ))}
    </ul>
    <ul className="link-default">
      {LINK_LIST.default.map(({ label, url }) => (
        <li key={label}>
          <NavLink to={url} aria-label={label}>
            {label}
          </NavLink>
        </li>
      ))}
    </ul>
  </nav>
);
